import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import TextField from '@material-ui/core/TextField';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';
import Typography from '@material-ui/core/Typography';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';

import config from "../../config/config";
import axios from 'axios';

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing.unit * 3,
        overflowX: 'auto',
    },
    table: {
        minWidth: 700,
    },
});

class TaskResponseDialog extends Component {
    state = {
        open: this.props.open,
        scroll: 'paper',
        requiredFields: [{
            id: 0,
            title: "",
            required: false,
            attachment: false
        }],
        value: 0,
        tasks: this.props.tasks
    };
    handleClose = () => {
        this.setState({ open: false });
        this.props.close();
    };
    handleChange = (event, value) => {
        this.setState({ value });
    };
    handleResponseOnChange = (e, id) =>{
        console.log(e.target.value + " in " +id)
        let updateObj = this.state.tasks.questions.find(o=>o.id == id);
        let updatequestionIndex = this.state.tasks.questions.indexOf(updateObj);
        if(e.target.name == "response"){
            updateObj.response = e.target.value;
            this.setState(state => {this.state.tasks.questions[updatequestionIndex] = updateObj});
        }
    };

    ResponseFileUpdateRequest = (formData) => {
         return axios.post(config.attachment, formData, {
             headers: {
                 'Content-Type': 'multipart/form-data'
             }
         }).then((res)=>{
             console.log("upload file res");
             console.log(res);
             this.setState({ tempID: res.data.id });
             return res.data.id;
         })
             .catch(err=>{ console.log(err.response); });
    };

    handleResponseAttachmentOnChange = (e, id) =>{
        let updateObj = this.state.tasks.questions.find(o=>o.id == id);
        let updatequestionIndex = this.state.tasks.questions.indexOf(updateObj);

        let attachment = e.target.files[0];

        var formData = new FormData();
        var uploads = attachment;
        console.log(uploads);
        formData.append("file", uploads);
        console.log ("formdata");
        console.log(formData);

        this.ResponseFileUpdateRequest(formData).then(data => {
            updateObj.attachment_id = this.state.tempID;
            console.log("updateobj");
            console.log(updateObj);
        });

        //updateObj.response = e.target.value;
        this.setState(state => {this.state.tasks.questions[updatequestionIndex] = updateObj});
    };


    ResponsePutRequest = (postObj) => {
        return axios.put(config.tasksSub(this.state.tasks.id),postObj)
            .then(res=>{
                console.log("this is the reesult of post request");
                console.log(res)})
            .catch(error=>{console.log(error.response)});
        
    };




    handleResponseSubmit = () => {
        let postObj = this.createResponseSubmitObj();
        this.ResponsePutRequest(postObj).then(res => {
            this.props.refreshTaskList();
            this.setState({ open: false });
            this.props.close();
        });
    };
    createResponseSubmitObj(){
        let submitObj = {};
        submitObj.id = this.state.tasks.id;
        submitObj.questions = this.state.tasks.questions;
        console.log("submit response obj");
        console.log(submitObj);
        return submitObj;
    }

/*    componentDidMount(){
            this.setState({tasks:this.props.tasks});
    }*/
    render() {
        console.log(this.state.tasks)
        let detailsView = (<div>
            <div style={{ height: "1vh" }}></div>
            <Table>
                <TableBody>
                    <TableRow>
                        <TableCell>
                            Task Name
                        </TableCell>
                        <TableCell>
                            Please collect order amount
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            Associated Alert
                        </TableCell>
                        <TableCell>
                            Missing Amount
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            Assigned By
                        </TableCell>
                        <TableCell>
                            Eric
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            Date Assigned
                        </TableCell>
                        <TableCell>
                            13-SEP-18 19:00
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            Response By
                        </TableCell>
                        <TableCell>
                            14-SEP-18 19:00
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell>
                            Entry Needed
                        </TableCell>
                        <TableCell>
                            3
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </div>);
        let responseView = (<div>
            <div style={{ height: "1vh" }}></div>
            <Typography variant="subheading">{this.props.tasks.description}{/*Please collect these information to facilitate closure of alert from SLA on 19th June 2016*/}</Typography>
            <div style={{ height: "1vh" }}></div>
            {this.state.tasks.questions
                .sort((a,b)=>(a.id > b.id) ? 1 : ((b.id > a.id)? -1 : 0))
                .map(t => {
                    console.log(t.id)
                    return (
                        <div key = {t.id}>
                            <Typography variant="subheading">{t.question_text + "*"}</Typography>
                            {t.question_type == "Attachment"?<span>
                                <input
                                    hidden
                                    id={"uploadFileButtonForResponse" + t.id }
                                    multiple 
                                    type="file"
                                    name={"attachemnt_id"}
                                    onChange = {(e) => {this.handleResponseAttachmentOnChange(e, t.id)}}
                                />
                                <label htmlFor={"uploadFileButtonForResponse" + t.id}>
                                    <Button variant="contained" component="span" size="small" >Attach File..</Button>
                                </label>
                            </span>:
                                <TextField
                                    margin="dense"
                                    id="name"
                                    placeholder="remarks"
                                    fullWidth
                                    name = {"response"}
                                    onChange = {(e) => {this.handleResponseOnChange(e, t.id)}}
                                />}
                            
                            
                            <div style={{ height: "1vh" }}></div>
                        </div>
                    )
                })
            }
        </div>);
        let tabs = (
            <div>
                <Tabs

                    value={this.state.value}
                    indicatorColor="primary"
                    textColor="primary"
                    onChange={this.handleChange}
                    centered
                >
                    <Tab label="Task Details" />
                    <Tab label="Response" />
                </Tabs>
                {this.state.value == 0 ? detailsView : null}
                {this.state.value === 1 ? responseView : null}
            </div>
        );
        return (
            <Dialog
                open={this.state.open}
                //onClose={this.handleClose}
                scroll={this.state.scroll}
                aria-labelledby="scroll-dialog-title"
            >
                <DialogTitle id="scroll-dialog-title">{"Response to Task: Alert  " + this.props.tasks.alert}</DialogTitle>
                <DialogContent style={{ width: "55vh", height: "50vh" }}>
                    {responseView}
                </DialogContent>
                <DialogActions>
                    <Button color="primary">
                        Save
                </Button>
                    <Button onClick={this.handleResponseSubmit}>
                        Send
                </Button>
                    <Button onClick={this.handleClose} color="secondary">
                        Discard
                </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

export default withStyles(styles)(TaskResponseDialog)


// WEBPACK FOOTER //
// ./src/components/KRI/TaskResponseDialog.js